import { Field, getIn } from 'formik';
import React from 'react';
import _ from 'lodash';
export const states = [
	{ value: '', label: 'Select an Option' },
	{ value: 'AL', label: 'Alabama' },
	{ value: 'AK', label: 'Alaska' },
	{ value: 'AZ', label: 'Arizona' },
	{ value: 'AR', label: 'Arkansas' },
	{ value: 'CA', label: 'California' },
	{ value: 'CO', label: 'Colorado' },
	{ value: 'CT', label: 'Connecticut' },
	{ value: 'DE', label: 'Delaware' },
	{ value: 'DC', label: 'District Of Columbia' },
	{ value: 'FL', label: 'Florida' },
	{ value: 'GA', label: 'Georgia' },
	{ value: 'HI', label: 'Hawaii' },
	{ value: 'ID', label: 'Idaho' },
	{ value: 'IL', label: 'Illinois' },
	{ value: 'IN', label: 'Indiana' },
	{ value: 'IA', label: 'Iowa' },
	{ value: 'KS', label: 'Kansas' },
	{ value: 'KY', label: 'Kentucky' },
	{ value: 'LA', label: 'Louisiana' },
	{ value: 'ME', label: 'Maine' },
	{ value: 'MD', label: 'Maryland' },
	{ value: 'MA', label: 'Massachusetts' },
	{ value: 'MI', label: 'Michigan' },
	{ value: 'MN', label: 'Minnesota' },
	{ value: 'MS', label: 'Mississippi' },
	{ value: 'MO', label: 'Missouri' },
	{ value: 'MT', label: 'Montana' },
	{ value: 'NE', label: 'Nebraska' },
	{ value: 'NV', label: 'Nevada' },
	{ value: 'NH', label: 'New Hampshire' },
	{ value: 'NJ', label: 'New Jersey' },
	{ value: 'NM', label: 'New Mexico' },
	{ value: 'NY', label: 'New York' },
	{ value: 'NC', label: 'North Carolina' },
	{ value: 'ND', label: 'North Dakota' },
	{ value: 'OH', label: 'Ohio' },
	{ value: 'OK', label: 'Oklahoma' },
	{ value: 'OR', label: 'Oregon' },
	{ value: 'PA', label: 'Pennsylvania' },
	{ value: 'RI', label: 'Rhode Island' },
	{ value: 'SC', label: 'South Carolina' },
	{ value: 'SD', label: 'South Dakota' },
	{ value: 'TN', label: 'Tennessee' },
	{ value: 'TX', label: 'Texas' },
	{ value: 'UT', label: 'Utah' },
	{ value: 'VT', label: 'Vermont' },
	{ value: 'VA', label: 'Virginia' },
	{ value: 'WA', label: 'Washington' },
	{ value: 'WV', label: 'West Virginia' },
	{ value: 'WI', label: 'Wisconsin' },
	{ value: 'WY', label: 'Wyoming' }
];

export const accessRoles = [
	{ id: 0, label: 'DS_DIRECT_CONSUMER' },
	{ id: 2, label: 'DS_DIRECT_PRO_ASSETS' },
	{ id: 3, label: 'DS_DIRECT_SHOREVIEW' },
	{ id: 4, label: 'DS_DIRECT_PROFESSIONAL' }
];

export const status = [
	{ value: 'ACTIVE', label: 'ACTIVE' },
	{
		value: 'FORCE_CHANGE_PASSWORD',
		label: 'FORCE_CHANGE_PASSWORD',
		disabled: true
	},
	{ value: 'DISABLED', label: 'DISABLED' }
];

export const ErrorMessage = ({ name, width = null }) => (
	<Field name={name}>
		{({ form }) => {
			const error = getIn(form.errors, name);
			const touch = getIn(form.touched, name);

			return touch && !!error ? <div style={{ color: 'red', marginTop: '.5rem', width: width }}>{error}</div> : null;
		}}
	</Field>
);

export const poolLabel = {
	'REPOST-DEV': 'REPOST-DEV',
};

export const roles = [
	'REPOST-DEV_VIEW',
	'REPOST-DEV_MODIFY',
	'REPOST-DEV_CREATE',
	'REPOST-DEV_ADMIN',
	'REPOST-DEV_REAPPROVE',
	'REPOST-DEV_REVIEW',
	'REPOST-DEV_RESET',
	'REPOST-DEV_GENERATE_REPORT',
];

export const stateCodes = [
	{ value: '', label: '' },
	{ value: '+1', label: '1' },
	{ value: '+2', label: '2' },
	{ value: '+3', label: '3' },
	{ value: '+4', label: '4' },
	{ value: '+5', label: '5' }
];

export const salesorgs=['','US00','CA00'];
export const countries = [
	'',
	'Afghanistan',
	'Ãland Islands',
	'Albania',
	'Algeria',
	'American Samoa',
	'Andorra',
	'Angola',
	'Anguilla',
	'Antarctica',
	'Antigua and Barbuda',
	'Argentina',
	'Armenia',
	'Aruba',
	'Australia',
	'Austria',
	'Azerbaijan',
	'Bahamas',
	'Bahrain',
	'Bangladesh',
	'Barbados',
	'Belarus',
	'Belgium',
	'Belize',
	'Benin',
	'Bermuda',
	'Bhutan',
	'Bolivia',
	'Bonaire',
	'Bosnia and Herzegovina',
	'Botswana',
	'Bouvet Island',
	'Brazil',
	'British Indian Ocean Territory',
	'Brunei Darussalam',
	'Bulgaria',
	'Burkina Faso',
	'Burundi',
	'Cambodia',
	'Cameroon',
	'Canada',
	'Cape Verde',
	'Cayman Islands',
	'Central African Republic',
	'Chad',
	'Chile',
	'China',
	'Christmas Island',
	'Cocos (Keeling) Islands',
	'Colombia',
	'Comoros',
	'Congo (the Democratic Republic of the)',
	'Congo',
	'Cook Islands',
	'Costa Rica',
	"Côte d'Ivoire",
	'Croatia',
	'Cuba',
	'Curaçao',
	'Cyprus',
	'Czech Republic',
	'Denmark',
	'Djibouti',
	'Dominica',
	'Dominican Republic',
	'Ecuador',
	'Egypt',
	'El Salvador',
	'Equatorial Guinea',
	'Eritrea',
	'Estonia',
	'Ethiopia',
	'Falkland Islands (Malvinas)',
	'Faroe Islands',
	'Fiji',
	'Finland',
	'France',
	'French Guiana',
	'French Polynesia',
	'French Southern Territories',
	'Gabon',
	'Gambia',
	'Georgia',
	'Germany',
	'Ghana',
	'Gibraltar',
	'Greece',
	'Greenland',
	'Grenada',
	'Guadeloupe',
	'Guam',
	'Guatemala',
	'Guernsey',
	'Guinea',
	'Guinea-Bissau',
	'Guyana',
	'Haiti',
	'Heard Island and McDonald Islands',
	'Holy See (Vatican City State)',
	'Honduras',
	'Hong Kong',
	'Hungary',
	'Iceland',
	'India',
	'Indonesia',
	'Iran (Islamic Republic of)',
	'Iraq',
	'Ireland',
	'Isle of Man',
	'Israel',
	'Italy',
	'Jamaica',
	'Japan',
	'Jersey',
	'Jordan',
	'Kazakhstan',
	'Kenya',
	'Kiribati',
	"Korea (the Democratic People's Republic of)",
	'Korea (the Republic of)',
	'Kuwait',
	'Kyrgyzstan',
	"Lao People's Democratic Republic",
	'Latvia',
	'Lebanon',
	'Lesotho',
	'Liberia',
	'Libya',
	'Liechtenstein',
	'Lithuania',
	'Luxembourg',
	'Macao',
	'Madagascar',
	'Malawi',
	'Malaysia',
	'Maldives',
	'Mali',
	'Malta',
	'Marshall Islands',
	'Martinique',
	'Mauritania',
	'Mauritius',
	'Mayotte',
	'Mexico',
	'Micronesia (Federated States of)',
	'Moldova (the Republic of)',
	'Monaco',
	'Mongolia',
	'Montenegro',
	'Montserrat',
	'Morocco',
	'Mozambique',
	'Myanmar',
	'Namibia',
	'Nauru',
	'Nepal',
	'Netherlands',
	'New Caledonia',
	'New Zealand',
	'Nicaragua',
	'Niger',
	'Nigeria',
	'Niue',
	'Norfolk Island',
	'North Macedonia',
	'Northern Mariana Islands',
	'Norway',
	'Oman',
	'Pakistan',
	'Palau',
	'Palestine',
	'Panama',
	'Papua New Guinea',
	'Paraguay',
	'Peru',
	'Philippines',
	'Pitcairn',
	'Poland',
	'Portugal',
	'Puerto Rico',
	'Qatar',
	'Réunion',
	'Romania',
	'Russian Federation',
	'Rwanda',
	'Saint Barthélemy',
	'Saint Helena',
	'Saint Kitts and Nevis',
	'Saint Lucia',
	'Saint Martin (French part)',
	'Saint Pierre and Miquelon',
	'Saint Vincent and the Grenadines',
	'Samoa',
	'San Marino',
	'Sao Tome and Principe',
	'Saudi Arabia',
	'Senegal',
	'Serbia',
	'Seychelles',
	'Sierra Leone',
	'Singapore',
	'Sint Maarten (Dutch part)',
	'Slovakia',
	'Slovenia',
	'Solomon Islands',
	'Somalia',
	'South Africa',
	'South Georgia and the South Sandwich Islands',
	'South Sudan',
	'Spain',
	'Sri Lanka',
	'Sudan',
	'Suriname',
	'Svalbard and Jan Mayen',
	'Swaziland',
	'Sweden',
	'Switzerland',
	'Syrian Arab Republic',
	'Taiwan (Province of China)',
	'Tajikistan',
	'Tanzania',
	'Thailand',
	'Timor-Leste',
	'Togo',
	'Tokelau',
	'Tonga',
	'Trinidad and Tobago',
	'Tunisia',
	'Turkey',
	'Turkmenistan',
	'Turks and Caicos Islands',
	'Tuvalu',
	'Uganda',
	'Ukraine',
	'United Arab Emirates',
	'United Kingdom of Great Britain and Northern Ireland',
	'United Kingdom',
	'United States Minor Outlying Islands',
	'United States of America',
	'Uruguay',
	'Uzbekistan',
	'Vanuatu',
	'Venezuela (Bolivarian Republic of)',
	'Viet Nam',
	'Virgin Islands (British)',
	'Virgin Islands (U.S.)',
	'Wallis and Futuna',
	'Western Sahara',
	'Yemen',
	'Zambia',
	'Zimbabwe'
];

export const countryCodes = {
	'REPOST-DEV': [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
};

// Removed other app configurations - keeping only REPOST-DEV
// Original apps: RE, WAS, PSE, SO, TA, ODW, AU, CMS, CMI, OCT, STK, PC
/*
OLD_countryCodes = {
	WAS: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	PSE: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	SO: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	TA: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	ODW: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	AU: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	CMS: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	CMI: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	OCT: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	STK: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	PC: [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Algeria: '213' },
		{ Andorra: '376' },
		{ Angola: '244' },
		{ Anguilla: '1264' },
		{ 'Antigua & Barbuda': '1268' },
		{ Argentina: '54' },
		{ Armenia: '374' },
		{ Aruba: '297' },
		{ Australia: '61' },
		{ Austria: '43' },
		{ Azerbaijan: '994' },
		{ Bahamas: '1242' },
		{ Bahrain: '973' },
		{ Bangladesh: '880' },
		{ Barbados: '1246' },
		{ Belarus: '375' },
		{ Belgium: '32' },
		{ Belize: '501' },
		{ Benin: '229' },
		{ Bermuda: '1441' },
		{ Bhutan: '975' },
		{ Bolivia: '591' },
		{ 'Bosnia Herzegovina': '387' },
		{ Botswana: '267' },
		{ Brazil: '55' },
		{ Brunei: '673' },
		{ Bulgaria: '359' },
		{ 'Burkina Faso': '226' },
		{ Burundi: '257' },
		{ Cambodia: '855' },
		{ Cameroon: '237' },
		{ 'Cape Verde Islands': '238' },
		{ 'Cayman Islands': '1345' },
		{ 'Central African Republic': '236' },
		{ Chile: '56' },
		{ China: '86' },
		{ Colombia: '57' },
		{ Comoros: '269' },
		{ Congo: '242' },
		{ 'Cook Islands': '682' },
		{ 'Costa Rica': '506' },
		{ Croatia: '385' },
		{ Cuba: '53' },
		{ 'Cyprus North': '90392' },
		{ 'Cyprus South': '357' },
		{ 'Czech Republic': '42' },
		{ Denmark: '45' },
		{ Djibouti: '253' },
		{ Dominica: '1809' },
		{ 'Dominican Republic': '1809' },
		{ Ecuador: '593' },
		{ Egypt: '20' },
		{ 'El Salvador': '503' },
		{ 'Equatorial Guinea': '240' },
		{ Eritrea: '291' },
		{ Estonia: '372' },
		{ Ethiopia: '251' },
		{ 'Falkland Islands': '500' },
		{ 'Faroe Islands': '298' },
		{ Fiji: '679' },
		{ Finland: '358' },
		{ France: '33' },
		{ 'French Guiana': '594' },
		{ 'French Polynesia': '689' },
		{ Gabon: '241' },
		{ Gambia: '220' },
		{ Georgia: '7880' },
		{ Germany: '49' },
		{ Ghana: '233' },
		{ Gibraltar: '350' },
		{ Greece: '30' },
		{ Greenland: '299' },
		{ Grenada: '1473' },
		{ Guadeloupe: '590' },
		{ Guam: '671' },
		{ Guatemala: '502' },
		{ Guinea: '224' },
		{ 'Guinea - Bissau': '245' },
		{ Guyana: '592' },
		{ Haiti: '509' },
		{ Honduras: '504' },
		{ 'Hong Kong': '852' },
		{ Hungary: '36' },
		{ Iceland: '354' },
		{ India: '91' },
		{ Indonesia: '62' },
		{ Iran: '98' },
		{ Iraq: '964' },
		{ Ireland: '353' },
		{ Israel: '972' },
		{ Italy: '39' },
		{ Jamaica: '1876' },
		{ Japan: '81' },
		{ Jordan: '962' },
		{ Kazakhstan: '7' },
		{ Kenya: '254' },
		{ Kiribati: '686' },
		{ 'Korea North': '850' },
		{ 'Korea South': '82' },
		{ Kuwait: '965' },
		{ Kyrgyzstan: '996' },
		{ Laos: '856' },
		{ Latvia: '371' },
		{ Lebanon: '961' },
		{ Lesotho: '266' },
		{ Liberia: '231' },
		{ Libya: '218' },
		{ Liechtenstein: '417' },
		{ Lithuania: '370' },
		{ Luxembourg: '352' },
		{ Macao: '853' },
		{ Macedonia: '389' },
		{ Madagascar: '261' },
		{ Malawi: '265' },
		{ Malaysia: '60' },
		{ Maldives: '960' },
		{ Mali: '223' },
		{ Malta: '356' },
		{ 'Marshall Islands': '692' },
		{ Martinique: '596' },
		{ Mauritania: '222' },
		{ Mayotte: '269' },
		{ Mexico: '52' },
		{ Micronesia: '691' },
		{ Moldova: '373' },
		{ Monaco: '377' },
		{ Mongolia: '976' },
		{ Montserrat: '1664' },
		{ Morocco: '212' },
		{ Mozambique: '258' },
		{ Myanmar: '95' },
		{ Namibia: '264' },
		{ Nauru: '674' },
		{ Nepal: '977' },
		{ Netherlands: '31' },
		{ 'New Caledonia': '687' },
		{ 'New Zealand': '64' },
		{ Nicaragua: '505' },
		{ Niger: '227' },
		{ Nigeria: '234' },
		{ Niue: '683' },
		{ 'Norfolk Islands': '672' },
		{ 'Northern Marianas': '670' },
		{ Norway: '47' },
		{ Oman: '968' },
		{ Palau: '680' },
		{ Panama: '507' },
		{ 'Papua New Guinea': '675' },
		{ Paraguay: '595' },
		{ Peru: '51' },
		{ Philippines: '63' },
		{ Poland: '48' },
		{ Portugal: '351' },
		{ 'Puerto Rico': '1787' },
		{ Qatar: '974' },
		{ Reunion: '262' },
		{ Romania: '40' },
		{ Russia: '7' },
		{ Rwanda: '250' },
		{ 'San Marino': '378' },
		{ 'Sao Tome & Principe': '239' },
		{ 'Saudi Arabia': '966' },
		{ Senegal: '221' },
		{ Serbia: '381' },
		{ Seychelles: '248' },
		{ 'Sierra Leone': '232' },
		{ Singapore: '65' },
		{ 'Slovak Republic': '421' },
		{ Slovenia: '386' },
		{ 'Solomon Islands': '677' },
		{ Somalia: '252' },
		{ 'South Africa': '27' },
		{ Spain: '34' },
		{ 'Sri Lanka': '94' },
		{ 'St. Helena': '290' },
		{ 'St. Kitts': '1869' },
		{ 'St. Lucia': '1758' },
		{ Sudan: '249' },
		{ Suriname: '597' },
		{ Swaziland: '268' },
		{ Sweden: '46' },
		{ Switzerland: '41' },
		{ Syria: '963' },
		{ Taiwan: '886' },
		{ Tajikstan: '7' },
		{ Thailand: '66' },
		{ Togo: '228' },
		{ Tonga: '676' },
		{ 'Trinidad & Tobago': '1868' },
		{ Tunisia: '216' },
		{ Turkey: '90' },
		{ Turkmenistan: '7' },
		{ Turkmenistan: '993' },
		{ 'Turks & Caicos Islands': '1649' },
		{ Tuvalu: '688' },
		{ Uganda: '256' },
		{ Ukraine: '380' },
		{ 'United Arab Emirates': '971' },
		{ Uruguay: '598' },
		{ Uzbekistan: '7' },
		{ Vanuatu: '678' },
		{ 'Vatican City': '379' },
		{ Venezuela: '58' },
		{ Vietnam: '84' },
		{ 'Virgin Islands - British': '1284' },
		{ 'Virgin Islands - US': '1340' },
		{ 'Wallis & Futuna': '681' },
		{ 'Yemen:North': '969' },
		{ 'Yemen:South': '967' },
		{ Zambia: '260' },
		{ Zimbabwe: '263' }
	],
	'REPOST-DEV': [
		{ UK: '44' },
		{ 'USA/Canada': '1' },
		{ Germany: '49' },
		{ France: '33' },
		{ Japan: '81' },
		{ Australia: '61' },
		{ India: '91' },
		{ China: '86' },
		{ Brazil: '55' },
		{ Canada: '1' }
	]
};
*/

export const formatCountryCodes = pool => {
	let codes = [''];
	countryCodes[pool].forEach(countryCode => {
		let code = parseInt(String(Object.values(countryCode)).trim());
		!codes.includes(code) && codes.push(code);
	});
	return _.sortBy(codes);
};

export const menu_privileges = {
	create: ['REPOST-DEV_CREATE'],
	modify: ['REPOST-DEV_MODIFY'],
	view: ['REPOST-DEV_VIEW'],
	reset: ['REPOST-DEV_RESET'],
	generateReport: ['REPOST-DEV_GENERATE_REPORT'],
	review: ['REPOST-DEV_REVIEW'],
	reapprove: ['REPOST-DEV_REAPPROVE'],
	manageAdmin: ['REPOST-DEV_ADMIN']
};
